import { css } from "@emotion/react";
import { bpoints } from "../../../../Utils";

export function buroContainerCSS(){
    return css`
        position: relative;
        z-index: 1;
    margin: auto 0;
        .TopText{
            color: #29588C;
            text-align: center;
            font-family: 'Neue Haas Grotesk Display Pro';
            font-size: calc(0.6rem + 1.4vw);
            font-style: normal;
            font-weight: 600;
            line-height: 105.405%;

            width: 60%;
            margin-top: 3.5rem;
            margin-bottom: 1rem;

            @media (max-width: ${bpoints.mobile.w}px){
                width: 100%;
                padding: 0 8vw;
                font-size: calc(1.4rem + 1.2vw);

            }
        }

        .InputsSection{
            display: flex;
            flex-direction: column;

            gap: 1rem;

            //width: 100%;


            .ButtonWithShadow{
                display: flex;
                flex-direction: column;
                width: fit-content;
                gap: 2rem;

                .Green{
                    background-color: #1FDD8F;
                    color: white;
                    font-size: calc(0.4rem + 0.7vw);
                    border-radius: 17px !important;
                    border: unset !important;
    
                    width: fit-content;
                    padding: 0 6rem;
                    :hover{
                        background-color: #2ad690;
    
                    }
                }
                .Shadow{
                    width: 100%;
                    height: 55px;
                    border-radius: 467px;
                    background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
                }
            }

        }
    `;
}